import { render, staticRenderFns } from "./CoreManager.vue?vue&type=template&id=94fc778e&scoped=true&"
import script from "./CoreManager.vue?vue&type=script&lang=js&"
export * from "./CoreManager.vue?vue&type=script&lang=js&"
import style0 from "./CoreManager.vue?vue&type=style&index=0&id=94fc778e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94fc778e",
  null
  
)

export default component.exports